import {
  OrthographicShapeState3D,
  ShapeState,
} from '../../cross-team-shared/annotation/shared/state/shape-state';
import { PointCloudShapeType } from '../../team-apis/otterdam/answers/point-cloud-answer';

export interface LineState3D extends OrthographicShapeState3D {
  type: Extract<PointCloudShapeType, 'line'>;
}

export function isLineState3D(shape: ShapeState): shape is LineState3D {
  return shape.type === 'line';
}
